<template>
  <div class="neitui">
    <c-tab :tabs="tabs">
      <template #operate>
        <el-button type="text" @click="open">查看奖励方案</el-button>
      </template>
    </c-tab>
  </div>
</template>

<script>
import CTab from '@/components/common/tab'
import * as types from '@/store/mutation-types'

export default {
  name: 'neitui',
  components: { CTab },
  data () {
    return {
      active: '0',
      tabs: [ {
        label: '在招岗位',
        component: () => import('./#zhiwei')
      }, {
        label: '我的推荐',
        component: () => import('./#me')
      } ]
    }
  },
  watch: {
    $route: {
      handler: function() {
        const crumbs = {
          path: this.$route.path,
          tabs: this.tabs
        }
        this.$store.commit(types.RECORD_GLOBAL_CRUMBSECOND, crumbs)
      },
      immediate: true
    }
  },
  methods: {
    open() {
      window.open(`/api/publish/get?publish_id=190`)
    }
  }
}
</script>

<style lang="scss">
</style>
